export const ACTIONS = {
  SET_STATUS: 'setStatusSearchInput',
  SET_STATUS_SEARCH_INPUT: 'setStatus',
  SET_COMPANY: 'setCompany',
  SET_COMPANY_SEARCH_INPUT: 'setCompanySearchInput',
  SET_ROLE: 'setRole',
  SET_ROLE_SEARCH_INPUT: 'setRoleSearchInput',
  SET_ACCESS_LEVEL: 'setAccessLevel',
  SET_ACCESS_LEVEL_SEARCH_INPUT: 'setAccessLevelSearchInput',
};
